import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { Certificate } from './certificate.interface';
export class CertificateService {
   async getCertificates(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Certificate>>>(`/certificates`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
